import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import useTspReverseGeocode from "../../hooks/useTspReverseGeocode";
import { pointFromSearch } from "../../utils/tspCoordinates";

// The map point Add Journey was opened with (/tsp/journeys/new?lat=&lng=, from
// "Create Journey" on the map): { point, invalid, geocode }.
//
// The URL is the source of truth, so a reload or a shared link still works;
// the answer the map already fetched for this same point comes along in the
// navigation state and is reused instead of asking the server again.
// `enabled` = the caller may create journeys (the lookup needs that permission).
export default function useTspJourneyMapPrefill({ enabled }) {
  const location = useLocation();
  const { point, invalid } = useMemo(() => pointFromSearch(location.search), [location.search]);
  const initial = (location.state && location.state.mapGeocode) || null;
  const geocode = useTspReverseGeocode(point, { enabled: Boolean(enabled && point), initial });
  return { point, invalid: Boolean(invalid), geocode };
}
